import {ChromaSlider} from "./chroma-slider";
import {LockableLabel} from "./lockable-label";
import {useThemeBuilder} from "./theme-builder-context";

/** Slider for the base gray-chroma parameter (0 → 0.02). */
export function BaseColorSlider() {
  const {params, setParam} = useThemeBuilder();
  const {base, hue} = params;

  return (
    <div className="flex flex-col gap-1">
      <LockableLabel
        label="Base"
        variable="base"
        tooltip="Controls how much color is in neutral tones"
      />
      <ChromaSlider
        className="h-6 w-40"
        value={base}
        hue={hue}
        onChange={(v) => setParam("base", v)}
      />
    </div>
  );
}
